import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('droneDetailsPage');

    return {
        APPLICATIONS: t('applications'),
        CLAIM_AIRCRAFT_CONFIRMATION: t('claimAircraftConfirmation'),
        CLAIM_BUTTON: t('claimButton'),
        CLAIM_OWNERSHIP: t('claimOwnership'),
        DISABLE: t('disable'),
        DISABLE_AIRCRAFT_CONFIRMATION: t('disableAircraftConfirmation'),
        DISABLE_AIRCRAFT_SUBTEXT: t('disableAircraftSubtext'),
        EDIT_DRONE: t('editDrone'),
        ENABLE: t('enable'),
        ENABLE_AIRCRAFT_CONFIRMATION: t('enableAircraftConfirmation'),
        ENABLE_AIRCRAFT_SUBTEXT: t('enableAircraftSubtext'),
        LINKED_ENTITIES: t('linkedEntities'),
        RELEASE_AIRCRAFT_CONFIRMATION: t('releaseAircraftConfirmation'),
        RELEASE_AIRCRAFT_SUBTEXT: t('releaseAircraftSubtext'),
        RELEASE_BUTTON: t('releaseButton'),
        RELEASE_OWNERSHIP: t('releaseOwnership')
    };
};

export default useTranslation;
